import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  wrapper: {
    display: "flex",
    marginBottom: theme.spacing(3),
  },
  idContainer: {
    display: "flex",
    flexDirection: "column",
  },
  headerData: {
    display: "flex",
    justifyContent: "space-between",
    width: "70%",
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
    },
  },
  clientInfo: {
    width: "50%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  internalInfo: {
    width: "50%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginTop: theme.spacing(2),
    },
  },
  title: {
    textTransform: "uppercase",
    color: "#00003D",
    opacity: "0.4",
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
  },
  data: {
    color: "#00003D",
    opacity: 1,
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
  },
  subtitle: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#00003D",
    opacity: 1,
    whiteSpace: "nowrap",
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
  },
  input: {
    color: "black!important",
  },
  inputRoot: {
    "&$disabled": {
      color: "red!important",
    },
  },
  textField: {
    "&.Mui-disabled": {
      color: "black",
    },
    "$.MuiInput-underline": {
      borderBottom: "none",
    },
  },
}))

export default styles
